import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'antd';

import FormCustomer from '@/components/Subscription/FormSub/Form/CustomerInfo';
import Cart from '@/components/Subscription/FormSub/Cart';
import './index.scss';
import { useTranslation } from 'react-i18next';

function CustomerInfo({ data, onCheckout, formData }) {
  const { t } = useTranslation();
  return (
    <div className="form-customer">
      <Row gutter={[16, 24]} className="form-subscribe__group">
        <Col lg={{ span: 15 }} span={24}>
          <div className="form-subscribe__title form-subscribe__title__group">
            <span className="form-subscribe__step">1</span>
            <h3>{t('subscribe_customer_info.title')}</h3>
          </div>
          <FormCustomer onCheckout={onCheckout} formData={formData} />
          <div className="form-subscribe__title form-subscribe__title__group">
            <span className="form-subscribe__step --empty">2</span>
            <h3>{t('subscriptions_page.payment.page_title')}</h3>
          </div>
        </Col>
        <Col lg={{ span: 9 }} span={24}>
          <Cart data={data} />
        </Col>
      </Row>
    </div>
  );
}

CustomerInfo.propTypes = {
  data: PropTypes.object,
  onCheckout: PropTypes.func,
  formData: PropTypes.object,
};

export default CustomerInfo;
